import React from 'react';
import injectSheet from 'react-jss';

import BackgroundImageSection from '../components/BackgroundImageSection';
import Section from '../components/Section';
import Link from '../components/Link';

const styles = {
    container: {
        '& li': {
            listStyle: 'none'
        }
    },
    sectionIndices: {
        '& > ul > li': {
            margin: '1.88rem 0',
            fontFamily: [ 'Noto Sans Bold', 'sans-serif' ],
            fontSize: '2.1rem'
        },
        '& > ul > ul > li': {
            margin: '1.88rem 0',
            fontFamily: [ 'Noto Sans Medium', 'sans-serif' ],
            fontSize: '1.4rem',
            textTransform: 'capitalize'
        },
        '& > ul > ul > ul > li': {
            margin: '1.5rem 0'
        },
        '& > ul > ul > ul > li > a': {
            color: '#0096C4',
            textDecoration: 'none'
        }
    },
    sectionAnswers: {
        '& > ul > li': {
            margin: '7.5rem 0 3.5rem 0',
            fontFamily: [ 'Noto Sans Bold', 'sans-serif' ],
            fontSize: '2.1rem',
            textTransform: 'capitalize'
        },
        '& > ul > ul > li': {
            margin: '3.5rem 0'
        },
        '& > ul > ul > li li': {
            margin: '0.5rem 0',
            listStyle: 'circle'
        },
        '& > ul > ul em': {
            fontStyle: 'normal',
            textDecoration: 'underline'
        }
    },
    answer: {
        paddingLeft: '1.25rem'
    },
    anchor: {
        display: 'block',
        position: 'relative',
        top: -84,
        visibility: 'hidden'
    }
};

export default injectSheet(styles)(({ classes, data }) => {
    const categories = [ 'general', 'troubleshooting' ];

    const indices = categories.map((category, index) => {
        return [(
            <li key="category">{category}</li>
        ), (
            <ul key="questions">
                { data.faqs.edges.map((faq, index) => {
                    return faq.node.frontmatter.category === category ? (
                        <li key={index}>
                            <Link to={`#${faq.node.internal.contentDigest}`}>
                                {faq.node.frontmatter.question}
                            </Link>
                        </li>
                    ) : null;
                })}
            </ul>
        )];
    });

    const answers = categories.map((category, index) => {
        return [(
            <li key="category">{category}</li>
        ), (
            <ul key="answers">
                { data.faqs.edges.map((faq, index) => {
                    return faq.node.frontmatter.category === category ? (
                        <li key={index}>
                            <a className={classes.anchor}
                               name={faq.node.internal.contentDigest}
                               />
                            <div>Q. {faq.node.frontmatter.question}</div>
                            <div
                                className={classes.answer}
                                dangerouslySetInnerHTML={{ __html: faq.node.html }} />
                        </li>
                    ) : null;
                })}
            </ul>
        )];        
    });
    
    return (
        <div className={classes.container}>
            <BackgroundImageSection
                sizesBackground={data.imageBackground.childImageSharp.sizes}>
                <h1>{data.contents.faq.title}</h1>
                <p>{data.contents.faq.description}</p>
            </BackgroundImageSection>
            <Section
                className={classes.sectionIndices}
                padding="2rem 0 0.5rem 0">
                <ul>
                    <li>Index</li>
                    <ul>
                        {indices}
                    </ul>
                </ul>
            </Section>
            <Section
                className={classes.sectionAnswers}
                padding="0 0 16rem 0">
                <ul>
                    {answers}
                </ul>
            </Section>
        </div>
    );
});

export const query = graphql`
    query IndexFaqQuery {
        ...IndexLayoutFragment
        ...IndexFaqFragment
    }

    fragment IndexFaqFragment on RootQueryType {
        imageBackground: file(relativePath: { eq: "bg_faq.jpg" }) {
            childImageSharp {
                sizes(maxWidth: 2000, quality: 90) {
                    ...GatsbyImageSharpSizes
                }
            }
        }

        contents: stringsToml {
            faq {
                title
                description
            }
        }

        faqs: allMarkdownRemark(
            filter: {
                frontmatter: { type: { eq: "faq" } }
            }, sort: {
                fields: [ frontmatter___order ],
                order: ASC
            }
        ) {
            edges {
                node {
                    internal {
                        contentDigest
                    }
                    frontmatter {
                        category
                        question
                    }
                    html
                }
            }
        }
    }
`;



// WEBPACK FOOTER //
// ./src/pages/faq.js